import React from 'react';
import TotalSales from 'components/common/glances/totalSalesGlance';
import TotalLabor from 'components/common/glances/totalLaborGlance';
import TopItem from 'components/common/glances/topItemGlance';
import TopServer from 'components/common/glances/topServerGlance';
import Discounts from 'components/common/glances/discountsGlance';
import Deletes from 'components/common/glances/deletesGlance';
import Overrings from 'components/common/glances/overringsGlance';
import Tips from 'components/common/glances/tipsGlance';
import Payments from 'components/common/glances/paymentsGlance';
import Taxes from 'components/common/glances/taxesGlance';
import Paidouts from 'components/common/glances/paidoutsGlance';
import DiningTimes from 'components/common/glances/diningTimesGlance';
import LaborCost from 'components/common/glances/laborCostGlance';
import ToggleHourlySalesCumuGlance from 'components/common/glances/hourlySalesCumuChartAndTableView/toggleHourlySalesCumuGlance';
import ToggleHourlySalesGlance from 'components/common/glances/hourlySalesChartAndTableView/toggleHourlySalesGlance';
import ToggleHourlyLaborGlance from 'components/common/glances/hourlyLaborChartAndTableView/toggleHourlyLaborGlance';
import ToggleHourlyLaborCumuGlance from 'components/common/glances/hourlyLaborCumuChartAndTableView/toggleHourlyLaborCumuGlance';
import ToggleCostCenterGlance from 'components/common/glances/costCenterChartAndTableView/toggleCostCenterGlance';
import ToggleCategorySalesGlance from 'components/common/glances/categorySalesChartAndTableView/toggleCategorySalesGlance';
import TestData from '../testData/testData';
import HourlySalesTestData from '../testData/hourlySalesTestData';
import HourlyLaborTestData from '../testData/hourlyLaborTestData';
import CostCenterTestData from '../testData/costCenterTestData';
import CategorySalesTestData from '../testData/categorySalesTestData';


export default function AllViews(props) {

  return (
    <>

      <div className='subtle'> As of: 2/18/20 10:15a </div>
      <div className='row grid-fix'>
        <TotalSales DP1={TestData.TotalSales.DP1} DP2={TestData.TotalSales.DP2} DP3={TestData.TotalSales.DP3} />
        <TotalLabor DP1={TestData.TotalLabor.DP1} DP2={TestData.TotalLabor.DP2} DP3={TestData.TotalLabor.DP3} />
        <TopItem DP1={TestData.TopItem.DP1} DP2={TestData.TopItem.DP2} DP3={TestData.TopItem.DP3} />
        <TopServer DP1={TestData.TopServer.DP1} DP2={TestData.TopServer.DP2} DP3={TestData.TopServer.DP3} />
        <Discounts DP1={TestData.Discounts.DP1} DP2={TestData.Discounts.DP2} DP3={TestData.Discounts.DP3} />
        <Deletes DP1={TestData.Deletes.DP1} DP2={TestData.Deletes.DP2} />
        <Overrings DP1={TestData.Overrings.DP1} DP2={TestData.Overrings.DP2} />
        <Tips DP1={TestData.Tips.DP1} DP2={TestData.Tips.DP2} />
        <Payments DP1={TestData.Tips.DP1} DP2={TestData.Tips.DP2} />
        <Taxes DP1={TestData.Taxes.DP1} DP2={TestData.Taxes.DP2} DP3={TestData.Taxes.DP3} />
        <Paidouts DP1={TestData.Paidouts.DP1} DP2={TestData.Paidouts.DP2} />
        <DiningTimes DP1={TestData.DiningTimes.DP1} />
        <LaborCost DP1={TestData.LaborCost.DP1} DP2={TestData.LaborCost.DP2} DP3={TestData.LaborCost.DP3} />

        {/* Chart and Table View Glances */}
        <ToggleHourlySalesCumuGlance data={HourlySalesTestData} />
        <ToggleHourlySalesGlance data={HourlySalesTestData} />
        <ToggleCostCenterGlance data={CostCenterTestData} />
        <ToggleCategorySalesGlance data={CategorySalesTestData} />
        <ToggleHourlyLaborCumuGlance data={HourlyLaborTestData} />
        <ToggleHourlyLaborGlance data={HourlyLaborTestData} />

      </div>

    </>
  );
}